export const SYSTEM_ERROR_OCCURED = "SYSTEM_ERROR_OCCURED";
export const CLEAN_ERRORS = "CLEAN_ERRORS";



// WEBPACK FOOTER //
// ./src/redux/actions/types/serviceNotificationActionTypes.js